import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { DIC } from '../../../../dic';
import { GN } from '../../../../../gn';

/**
 * Generated class for the QualitycontrolquestionsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-qualitycontrolquestions',
  templateUrl: 'qualitycontrolquestions.html',
})
export class QualitycontrolquestionsPage {

  questions = []
  drn: any;

  constructor(public dic: DIC, public gn: GN, public navCtrl: NavController, public navParams: NavParams, public toastCtrl: ToastController) {
    this.drn = this.navParams.get('drn')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad QualitycontrolquestionsPage');
    this.loadData()
  }

  loadData() {
    var _that = this
    this.gn._Post('/api/gn/getindoorquestionsbyorder', { cid: this.gn.crypt(this.gn.user.ClientId), orderid: this.gn.crypt(this.drn.id) }, function (_data) {
      _that.questions = _data.data
      for (var i = 0; i < _that.questions.length; i++) {
        if (_that.questions[i].tf == 0) {
          _that.questions[i].tfy = false;
          _that.questions[i].tfn = true;
        }
        else {
          _that.questions[i].tfy = true;
          _that.questions[i].tfn = false;
        }
      }
    })
  }
  saveQuestions() {

    var _sql = `delete from indoorquestionsbyroute where routeid=` + this.drn.id + `; `
    for (var q = 0; q < this.questions.length; q++) {
      _sql = _sql + `insert into indoorquestionsbyroute (questionid, routeid, tf, clientid, userid)
      values(`+ this.questions[q].id + `, ` + this.drn.id + `, ` + this.questions[q].tf + `::bit(1), ` + this.gn.user.ClientId + `, ` + this.gn.user.UserId + `); `
    }
    //debugger
    var _that = this
    this.gn._Post('/api/gn/insertindoorquestionsbyorder', { sql: this.gn.crypt(_sql), comm: this.gn.crypt(this.drn.qcomment), routeid: this.gn.crypt(this.drn.id) }, function (_data) {
      _that.navCtrl.pop()

      var cb = _that.navParams.get('cb')
      cb();

      const toast = _that.toastCtrl.create({ message: _that.dic.l["succsaved1"], duration: 3000, position: 'top' });
      toast.present();
      return
    })
  }

  settfy(ev: any, _idx) {
    var _that = this
    var _ch = ev.value;
    this.questions[_idx].tfn = !_ch
    this.questions[_idx].tfy = _ch
    this.questions[_idx].tf = _ch == false ? 0 : 1
  }

  settfn(ev: any, _idx) {
    var _that = this
    var _ch = ev.value;
    this.questions[_idx].tfn = _ch
    this.questions[_idx].tfy = !_ch
    this.questions[_idx].tf = _ch == false ? 1 : 0
  }

}



// WEBPACK FOOTER //
// ./src/pages/routing/routeindoor/qualitycontrol/qualitycontrolquestions/qualitycontrolquestions.ts